import { MessageSquare, Trash2, Plus } from "lucide-react";

const when = (iso) => {
  const d = new Date(iso);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return d.toLocaleTimeString("fr-BE", { hour: "2-digit", minute: "2-digit" });
  return d.toLocaleDateString("fr-BE", { day: "2-digit", month: "short" });
};

export const AssistantHistory = ({ chat, onPick, prefix = "assistant" }) => {
  const { chats, chatId, open, startNew, remove } = chat;
  const pick = async (id) => { await open(id); onPick?.(); };
  return (
    <div data-testid={`${prefix}-history`} className="flex h-full flex-col">
      <button type="button" data-testid={`${prefix}-new-chat`} onClick={async () => { await startNew(); onPick?.(); }} className="mx-3 mt-3 inline-flex min-h-[42px] items-center justify-center gap-2 rounded-xl bg-[#3A5CC8] shadow-[0_1px_2px_rgba(15,38,69,0.14)] px-4 text-sm font-semibold text-white hover:bg-[#2F4CA8]">
        <Plus className="h-4 w-4" /> Nouvelle conversation
      </button>
      <div className="mt-3 flex-1 space-y-0.5 overflow-y-auto px-2 pb-3">
        {chats.length === 0 && <p className="px-3 py-6 text-center text-sm text-[#93A0BC]">Aucune conversation pour l'instant.</p>}
        {chats.map((c) => (
          <div key={c.id} className={`group flex items-center gap-2 rounded-xl px-2 py-1 ${c.id === chatId ? "bg-[#EEF1FC]" : "hover:bg-[#F6F8FD]"}`}>
            <button type="button" data-testid={`${prefix}-chat-${c.id}`} onClick={() => pick(c.id)} className="flex min-w-0 flex-1 items-center gap-2.5 py-1.5 text-left">
              <MessageSquare className={`h-4 w-4 shrink-0 ${c.id === chatId ? "text-[#3A5CC8]" : "text-[#93A0BC]"}`} />
              <span className="min-w-0 flex-1">
                <span className="block truncate text-sm font-medium text-[#0F2645]">{c.title || "Nouvelle conversation"}</span>
                <span className="block text-[11px] text-[#93A0BC]">{when(c.updated_at)}</span>
              </span>
            </button>
            <button type="button" data-testid={`${prefix}-delete-${c.id}`} onClick={() => remove(c.id)} className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[#C9D4F4] opacity-0 transition-opacity hover:bg-rose-50 hover:text-rose-600 group-hover:opacity-100 focus:opacity-100" aria-label="Supprimer">
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};
